import type { OrderProduct } from "../OrderProduct.js";

export function isSameOrderProduct(first: OrderProduct, second: OrderProduct): boolean {
	const conditions = [
		first.info.id === second.info.id,
		first.info.variant.id === second.info.variant.id,
		first.info.attributes.length === second.info.attributes.length,
		first.info.attributes.every((first) => second.info.attributes.some((second) => first.value.id === second.value.id)),
	];
	return conditions.every(Boolean);
}
